import Model from 'src/app/core/models/model';

export default class FeatureModel extends Model {
  name: string;
  status?: Status;

  constructor() {
    super();
  }
}

export type Status = 'Active' | 'Inactive';
